
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/actuary/eupheus",
      function () {
        return require("private-next-pages/actuary/eupheus.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/actuary/eupheus"])
      });
    }
  